export default __webpack_public_path__ + "static/media/9.544b39f6.png";